import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import acl from './acl'
import axios from 'axios'
import i18n from './i18n'
import { vfmPlugin } from 'vue-final-modal'
import { defineRule } from 'vee-validate'
import Toast, { POSITION } from 'vue-toastification'
import './css/main.css'
import 'vue-toastification/dist/index.css'
import CountryFlag from 'vue-country-flag-next'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import VueProgressBar from '@aacassandra/vue3-progressbar'
import { setHeaderToken } from './utils/auth'
import '../node_modules/vue-select/dist/vue-select.css'
import { abilitiesPlugin } from '@casl/vue'
import ability from './services/ability'
import FloatingVue from 'floating-vue'
import logoutPlugin from 'vue-auto-logout'
import EasySlider from 'vue-easy-slider'
// Vue.config.productionTip = false;

import '@/assets/style/customTheme.scss'
import '@/css/dashboard.scss'

import VueGoogleLogin from 'vue3-google-login'

// new Vue({
//   render: h => h(App)
// }).$mount("#app");

// axios.defaults.baseURL = 'http://192.168.223.46/api/v1/'
// axios.defaults.baseURL = 'http://localhost:8000/api/v1/'
// axios.defaults.baseURL = 'http://192.168.1.18:8050/api/v1/'
// axios.defaults.baseURL = 'http://192.168.1.164:8000/api/v1/'
// axios.defaults.baseURL = 'http://192.168.43.68:8000/api/v1/'
//  axios.defaults.baseURL = 'http://103.3.62.193:8181/api/v1/'
// axios.defaults.baseURL = 'https://edu-demo.amatraedu.com:8081/api/v1/'
// axios.defaults.baseURL = 'https://sistem.kanisius.sch.id:8082/api/v1/'

// axios.defaults.baseURL = 'https://dharmasuci-demo.amatraedu.com:8181/api/v1/'
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL + 'api/v1/'

// axios.interceptors.response.use(function (response) {
//   console.log(response)n
// })
/* Fetch sample data */
// store.dispatch('fetch', 'clients')
// store.dispatch('fetch', 'history')

/* Dark mode */
// store.dispatch('darkMode')
const token = localStorage.getItem('token')
if (token) {
  setHeaderToken(token)
}

/* Collapse mobile aside menu on route change */
router.beforeEach(to => {
  store.dispatch('asideMobileToggle', false)
  store.dispatch('asideLgToggle', false)
})

/* Default title tag */
const defaultDocumentTitle = process.env.VUE_APP_TITLE

router.afterEach(to => {
  /* Set document title from route meta */
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} — ${defaultDocumentTitle}`
  } else {
    document.title = defaultDocumentTitle
  }

  /* Full screen mode */
  store.dispatch('fullScreenToggle', !!to.meta.fullScreen)
})

// global validation
defineRule('required', value => {
  if (!value || !value.length) {
    return 'This field is required'
  }
  return true
})
defineRule('email', value => {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true
  }
  // Check if email
  if (!/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/.test(value)) {
    return 'This field must be a valid email'
  }
  return true
})

// options NPprogressbar
const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 1300
  },
  autoRevert: true,
  location: 'top',
  autoFinish: false,
  position: 'absolute'
}
const logoutOptions = {
  stagnateTime: 30 * 60 * 1000,
  detectTime: 30 * 60
}

// console.log('ability')
// console.log(ability.can('read', { subject: 'students' }))

store.dispatch('get_user', token)
  .then(() => {
    createApp(App)
      .use(abilitiesPlugin, ability, {
        useGlobalProperties: true
      })
      .use(i18n)
      .use(FloatingVue)
      .use(VueProgressBar, options)
      .use(CountryFlag)
      .use(vfmPlugin({
        key: '$vfm',
        componentName: 'VueFinalModal',
        dynamicContainerName: 'ModalsContainer'
      }))
      .use(router, axios)
      .use(store)
      .use(acl)
      .use(Toast, { position: POSITION.BOTTOM_RIGHT })
      .use(logoutPlugin, logoutOptions)
      .use(EasySlider)
      .use(VueGoogleLogin, {
        clientId: '228231013612-9qo9vths81n9fbp0tj1dcqiig9v0j3s2.apps.googleusercontent.com', // Replace with your Google Client ID
        redirectUri: 'http://localhost:8080'
      })
      .mount('#app')
  }).catch((error) => {
    console.error(error)
  })
